export const CHARACTER_INIT = 'sheet.CHARACTER_INIT';
export const CHARACTER_RECEIVE_FAIL = 'sheet.CHARACTER_RECEIVE_FAIL';
export const SHARE_URL = 'sheet.SHARE_URL';
export const EXPORT_PDF = 'sheet.EXPORT_PDF';
